const DisplayAnswers = ({ children }) => {
  return <>{children}</>;
};

export default DisplayAnswers;
